import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black" data-testid="protected-loading">
        <p className="font-display tracking-extreme text-white/40 text-2xl">Tracking…</p>
      </div>
    );
  }
  if (!user || !user.id) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return children;
}
